import { render, staticRenderFns } from "./baseInfoView.vue?vue&type=template&id=06145dff&scoped=true"
import script from "./baseInfoView.vue?vue&type=script&lang=js"
export * from "./baseInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06145dff",
  null
  
)

export default component.exports